export const ADMIN_TYPE = {
  SUPER_ADMIN: 'super_admin',
  CHECKER: 'checker',
  ADMIN_0: 'admin_0',
  ADMIN_0_1: 'admin_0_1',
  ADMIN_1: 'admin_1',
  ADMIN_2: 'admin_2',
};
